import React from 'react'

const Star = () => {
  return (
    <div>Star</div>
  )
}

export default Star